<template>
	<div :class="theme">
    <div v-if="jsonData.pcBg!=='' && jsonData.pcBg!==null">
      <img :src="jsonData.pcBg" style="width: 100%; height: 100%;">
    </div>
		<div class="home" v-if="jsonData.pcBg==='' || jsonData.pcBg===null">
			<div v-if="theme == 'blue'" class="content">
				<div class="left">
					<div :class="theme == 'blue' && this.isLongChart ? 'name1' : 'name'">{{ jsonData.companyName }}</div>
					<div :class="theme == 'blue' && this.isLongChart ? 'en-name1' : 'en-name'">{{ jsonData.companyNameEng }}</div>
					<div class="line">
						<div class="line-bg"></div>
					</div>
					<div class="title">{{ jsonData.fs }}</div>
					<div class="en-title">{{ jsonData.fsEng }}</div>
					<div class="code">
						<div class="code-bg">
							<span v-if="language === 'zh'" class="text"> 股票代码：{{ jsonData.companyCode }} | 所属行业：{{ jsonData.xfhy }}</span>
							<span v-else-if="language === 'en'" class="text f-14"> Stock Code：{{ jsonData.companyCode }} ｜ Industry： {{ jsonData.xfhyEng }}</span>
						</div>
					</div>
				</div>
				<div class="right">
					<img src="../assets/image/blue/home_right.png" />
				</div>
			</div>
			<div v-else class="content">
				<div class="name">{{ jsonData.companyName }}</div>
				<div class="en-name">{{ jsonData.companyNameEng }}</div>
				<div class="line">
					<div class="line-bg"></div>
				</div>
				<div class="title">{{ jsonData.fs }}</div>
				<div class="en-title">{{ jsonData.fsEng }}</div>
				<div class="code">
					<div class="code-bg">
						<span v-if="language === 'zh'" class="text"> 股票代码：{{ jsonData.companyCode }} | 所属行业：{{ jsonData.xfhy }}</span>
						<span v-else-if="language === 'en'" class="text f-14"> Stock Code：{{ jsonData.companyCode }} ｜ Industry： {{ jsonData.xfhyEng }}</span>
					</div>
				</div>
			</div>
			<div class="logo">
				<img :src="logoImg" />
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
export default {
	name: 'home',
	data() {
		return {}
	},
	computed: {
		...mapState(['theme', 'language', 'jsonData', 'isLongChart']),
		logoImg() { // 获取logo图片地址
			return require('../assets/image/' + this.theme + '/logo.png')
		},
	},
	methods: {},
}
</script>

<style lang="scss" scoped>
.red {
	.home {
		width: 1140px;
		height: 720px;
		position: relative;
		background-image: url(../assets/image/red/bg_shouye.jpg);
		background-repeat: no-repeat;
		background-size: 100% 100%;
		.content {
			position: absolute;
			top: 219px;
			right: 101px;
			text-align: right;
			display: flex;
			flex-direction: column;
			justify-content: end;

			.name {
				height: 73px;
				font-size: 52px;
				font-weight: 600;
				color: var(--baseColor);
				line-height: 73px;
			}
			.en-name {
				height: 25px;
				font-size: 18px;
				font-weight: 600;
				color: var(--baseColor);
				line-height: 25px;
			}
			.line {
				display: flex;
				justify-content: end;
				margin-top: 11px;
				margin-bottom: 25px;
			}
			.line-bg {
				width: 61px;
				height: 6px;
				background: var(--baseColor);
			}

			.title {
				height: 62px;
				font-size: 44px;
				font-weight: 600;
				color: var(--timeTitleColor);
				line-height: 62px;
			}

			.en-title {
				height: 25px;
				font-size: 18px;
				font-weight: 600;
				color: var(--timeTitleColor);
				line-height: 25px;
			}
			.code {
				display: flex;
				justify-content: end;
				margin-top: 11px;
			}
			.code-bg {
				height: 22px;
				background: var(--baseColor);
				border-radius: 4px;
				padding: 7px 10px 6px 15px;
			}
			.text {
				height: 22px;
				font-size: 16px;
				font-weight: 600;
				color: #ffffff;
				line-height: 22px;
			}
			.f-14 {
				font-size: 14px;
			}
		}
		.logo {
			position: absolute;
			left: 50px;
			bottom: 38px;
		}
		.logo img {
			width: 112px;
			height: 35px;
		}
	}
}
.purple {
	.home {
		width: 1140px;
		height: 720px;
		position: relative;
		background-image: url(../assets/image/purple/bg_shouye.jpg);
		background-repeat: no-repeat;
		background-size: 100% 100%;
		display: flex;
		justify-content: center;
		align-items: center;

		.content {
			text-align: center;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			.name {
				height: 78px;
				font-weight: 600;
				font-size: 56px;
				line-height: 78px;
				letter-spacing: 2px;
				color: var(--baseColor);
			}
			.en-name {
				margin-top: 6px;
				height: 30px;
				font-weight: 600;
				font-size: 22px;
				line-height: 30px;
				color: var(--baseColor);
			}
			.line {
				display: none;
			}
			.line-bg {
				width: 61px;
				height: 6px;
				background: var(--baseColor);
			}

			.title {
				margin-top: 25px;
				height: 62px;
				font-weight: 600;
				font-size: 44px;
				color: #341e52;
				line-height: 62px;
				letter-spacing: 1px;
			}

			.en-title {
				margin-top: 6px;
				height: 30px;
				font-weight: 600;
				font-size: 22px;
				color: #341e52;
				line-height: 30px;
			}
			.code {
				display: flex;
				justify-content: end;
				margin-top: 11px;
			}
			.code-bg {
				margin-top: 31px;
				padding: 7px 21px;
				background: #ffffff;
				border-radius: 18px;
			}
			.text {
				height: 22px;
				font-weight: 600;
				font-size: 16px;
				color: #5b3f81;
				line-height: 22px;
			}
			.f-14 {
				font-size: 14px;
			}
		}
		.logo {
			position: absolute;
			right: 68px;
			bottom: 38px;
		}
		.logo img {
			width: 112px;
			height: 35px;
		}
	}
}
.blue {
	.home {
		width: 1140px;
		height: 720px;
		position: relative;
		background-image: url(../assets/image/blue/bg.jpg);
		background-repeat: no-repeat;
		background-size: 100% 100%;
		display: flex;
		align-items: center;

		.content {
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;

			.left {
				max-width: 520px;
			}

			.right img {
				width: 428px;
				height: 388px;
				transform: scaleX(-1);
			}
			.name {
				height: 78px;
				font-weight: 600;
				font-size: 56px;
				line-height: 78px;
				letter-spacing: 2px;
				background-image: linear-gradient(0deg, #4782ea 0%, #5db6fc 100%);
				-webkit-background-clip: text; /* Safari需要这个前缀 */
				-webkit-text-fill-color: transparent; /* Safari需要这个前缀来设置文字颜色为透明 */
				background-clip: text;
				text-fill-color: transparent; /* 设置文字颜色为透明，以便背景渐变可见 */
			}
      .name1 {
        height: 78px;
        font-weight: 600;
        font-size: 56px;
        line-height: 78px;
        letter-spacing: 2px;
        color: #5db6fc;
      }
			.en-name {
				margin-top: 6px;
				height: 30px;
				font-weight: 600;
				font-size: 22px;
				line-height: 30px;
				background-image: linear-gradient(0deg, #4782ea 0%, #5db6fc 100%);
				-webkit-background-clip: text; /* Safari需要这个前缀 */
				-webkit-text-fill-color: transparent; /* Safari需要这个前缀来设置文字颜色为透明 */
				background-clip: text;
				text-fill-color: transparent; /* 设置文字颜色为透明，以便背景渐变可见 */
			}
      .en-name1 {
        margin-top: 6px;
        height: 30px;
        font-weight: 600;
        font-size: 22px;
        line-height: 30px;
        color: #5db6fc;
      }
			.line {
				display: none;
			}
			.line-bg {
				width: 61px;
				height: 6px;
				background: var(--baseColor);
			}

			.title {
				margin-top: 25px;
				height: 62px;
				font-weight: 600;
				font-size: 44px;
				color: #0a0a0a;
				line-height: 62px;
				letter-spacing: 1px;
			}

			.en-title {
				margin-top: 6px;
				height: 30px;
				font-weight: 600;
				font-size: 22px;
				color: #0a0a0a;
				line-height: 30px;
			}
			.code {
				display: flex;
				margin-top: 11px;
			}
			.code-bg {
				margin-top: 31px;
				padding: 7px 12px;
				background: linear-gradient(90deg, #4782ea 0%, #5db6fc 100%);
				border-radius: 4px;
			}
			.text {
				height: 22px;
				font-weight: 600;
				font-size: 16px;
				color: #ffffff;
				line-height: 22px;
			}
			.f-14 {
				font-size: 14px;
			}
		}
		.logo {
			position: absolute;
			right: 68px;
			bottom: 38px;
		}
		.logo img {
			width: 112px;
			height: 35px;
		}
	}
}
.yellow {
	.home {
		width: 1140px;
		height: 720px;
		position: relative;
		background-image: url(../assets/image/yellow/bg.png);
		background-repeat: no-repeat;
		background-size: 100% 100%;
		display: flex;
		justify-content: center;
		align-items: center;

		.content {
			text-align: center;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			.name {
				height: 78px;
				font-weight: 600;
				font-size: 56px;
				line-height: 78px;
				letter-spacing: 2px;
				color: #0a0a0a;
			}
			.en-name {
				margin-top: 6px;
				height: 30px;
				font-weight: 600;
				font-size: 22px;
				line-height: 30px;
				color: #0a0a0a;
			}
			.line {
				display: none;
			}
			.line-bg {
				width: 61px;
				height: 6px;
				background: var(--baseColor);
			}

			.title {
				margin-top: 25px;
				height: 62px;
				font-weight: 600;
				font-size: 44px;
				color: #0a0a0a;
				line-height: 62px;
				letter-spacing: 1px;
			}

			.en-title {
				margin-top: 6px;
				height: 30px;
				font-weight: 600;
				font-size: 22px;
				color: #0a0a0a;
				line-height: 30px;
			}
			.code {
				display: flex;
				justify-content: end;
				margin-top: 11px;
			}
			.code-bg {
				margin-top: 11px;
				padding: 7px 13px;
				background: #151517;
				border-radius: 4px;
				max-width: 460px;
			}
			.text {
				height: 22px;
				font-weight: 600;
				font-size: 16px;
				color: #ffffff;
				line-height: 22px;
			}
			.f-14 {
				font-size: 14px;
			}
		}
		.logo {
			position: absolute;
			right: 68px;
			bottom: 38px;
		}
		.logo img {
			width: 112px;
			height: 35px;
		}
	}
}
</style>
